import React from "react";

function GalleryImages() {
    return (
        <div className="main-content">
            <div className="rs-breadcrumbs breadcrumbs-overlay">
                <div className="breadcrumbs-img">
                    <img src="assets/images/giving.jpg" alt="gallery" />
                </div>
                <div className="breadcrumbs-text white-color">
                    <h1 className="page-title">Gallery</h1>
                </div>
            </div>
            <div className="gallery-head" style={{fontSize: "22px", color: "#e12323", textAlign: "center", marginTop: '20px', fontWeight: "bold" }}>LAUNCH OF CFIITM</div>

            <div className="rs-gallery pt-30 pb-50 md-pt-70 md-pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 mb-30 col-md-6">
                            <div className="gallery-img">
                                <a className="image-popup" href="assets/images/l1.jpg"><img src="assets/images/l1.jpg" alt="image1" /></a>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-30 col-md-6">
                            <div className="gallery-img">
                                <a className="image-popup" href="assets/images/l2.jpg"><img src="assets/images/l2.jpg" alt="image2" /></a>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-30 col-md-6">
                            <div className="gallery-img">
                                <a className="image-popup" href="assets/images/l3.jpg"><img src="assets/images/l3.jpg" alt="image3" /></a>
                            </div>
                        </div>                        
                        <div className="col-lg-4 md-mb-30 col-md-6">
                            <div className="gallery-img">
                            <a className="image-popup" href="assets/images/l4.jpg"><img src="assets/images/l4.jpg" alt="image4" /></a>
                            </div>
                        </div>
                        <div className="col-lg-4 sm-mb-30 col-md-6">
                            <div className="gallery-img">
                            <a className="image-popup" href="assets/images/l5.jpg"><img src="assets/images/l5.jpg" alt="image5" /></a>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-img">
                            <a className="image-popup" href="assets/images/l6.jpg"><img src="assets/images/l6.jpg" alt="image6" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GalleryImages;